import React, { useEffect, useMemo } from 'react';
import {
  Menu,
  Segment,
  Dimmer,
  Loader,
  Dropdown,
  Input,
  Pagination,
  Table,
  Icon,
} from 'semantic-ui-react';
import moment from 'moment';
import CompanyManageExpiredEditPopup from '../CompanyManageExpiredEditPopup';
import CompanyManageNumberEditPopup from '../CompanyManageNumberEditPopup';
import CompanyManageActionsPopup from '../CompanyManageActionsPopup';
import api from '../../api';
import Config from '../../constants/Config';
import styles from './UserManage.module.scss';
const options = [
  {
    key: '1',
    text: '普通用户',
    value: '1',
  },
  {
    key: '2',
    text: '付费用户',
    value: '2',
  },
];

const bindWechatOptions = [
  {
    key: '1',
    text: '微信',
    value: '1',
  },
  {
    key: '2',
    text: '企业微信',
    value: '2',
  },
];

const UserManage = React.memo(() => {
  const [menu, setMenu] = React.useState('company');
  const [companyId, setCompanyId] = React.useState();
  const [isLoad, setIsLoad] = React.useState(false);
  const [type, setType] = React.useState();
  const [bindWechatType, setBindWechatType] = React.useState();
  const [company, setCompany] = React.useState({
    search: '',
    list: [],
    total: 0,
    currentSkip: 1,
  });
  const [member, setMember] = React.useState({
    search: '',
    list: [],
    total: 0,
    currentSkip: 1,
  });
  const [sortable, setSortable] = React.useState({
    column: null,
    direction: null,
  });
  const selectedMenuItem = useMemo(() => {
    if (menu === 'company') {
      return company;
    }
    return member;
  }, [menu, company, member]);

  const handleFieldChange = (e, { value }) => {
    if (menu === 'company') {
      setCompany((prevList) => {
        const newList = { ...prevList };
        newList.search = value;
        return newList;
      });
    } else {
      setMember((prevList) => {
        const newList = { ...prevList };
        newList.search = value;
        return newList;
      });
    }
  };

  const init = React.useCallback(() => {
    setIsLoad(true);
    if (!companyId && menu === 'company') {
      api
        .getUserManage({
          limit: Config.AONNOUCEMENT_LIMIT,
          skip: selectedMenuItem.currentSkip - 1,
          search: selectedMenuItem.search,
          type,
        })
        .then((res) => {
          setCompany((prevList) => {
            const newList = { ...prevList };
            newList.list = res.item;
            newList.total = res.total;
            return newList;
          });
        })
        .finally(() => {
          setIsLoad(false);
        });
    }
    if (menu === 'member' || companyId) {
      api
        .getUserManageDetails({
          bindWechatType,
          companyId,
          search: selectedMenuItem.search,
          limit: Config.AONNOUCEMENT_LIMIT,
          skip: selectedMenuItem.currentSkip - 1,
          sortable: sortable.column
            ? `${sortable.column} ${sortable.direction === 'ascending' ? 'asc' : 'desc'}`
            : '',
        })
        .then((res) => {
          setMember((prevList) => {
            const newList = { ...prevList };
            newList.list = res.item;
            newList.total = res.total;
            return newList;
          });
        })
        .finally(() => {
          setIsLoad(false);
        });
    }
  }, [
    companyId,
    menu,
    selectedMenuItem.currentSkip,
    selectedMenuItem.search,
    type,
    bindWechatType,
    sortable,
  ]);
  // 绑定方式
  const bindType = (item) => {
    if (item.wxWorkOpenid && item.wxOpenid) {
      return '微信、企业微信';
    }
    if (item.wxWorkOpenid) {
      return '企业微信';
    }
    if (item.wxOpenid) {
      return '微信';
    }
    return '-';
  };
  const handleMenberTypeChange = (e, { value }) => {
    setType(value);
    setCompany((prevList) => {
      const newList = { ...prevList };
      newList.currentSkip = 1;
      return newList;
    });
  };
  const handleMenberbindWechatTypeChange = (e, { value }) => {
    setBindWechatType(value);
    setMember((prevList) => {
      const newList = { ...prevList };
      newList.currentSkip = 1;
      return newList;
    });
  };

  const handlePageChange = (e, { activePage }) => {
    if (menu === 'company') {
      setCompany((prevList) => {
        const newList = { ...prevList };
        newList.currentSkip = activePage;
        return newList;
      });
    } else {
      setMember((prevList) => {
        const newList = { ...prevList };
        newList.currentSkip = activePage;
        return newList;
      });
    }
  };
  const again = () => {
    if (menu === 'company') {
      setCompany((prevList) => {
        const newList = { ...prevList };
        newList.currentSkip = 1;
        return newList;
      });
    }
    if (menu === 'member') {
      setMember((prevList) => {
        const newList = { ...prevList };
        newList.currentSkip = 1;
        return newList;
      });
    }
    init();
  };
  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      again();
    }
  };
  const onMenuCompanyClick = () => {
    setMenu('company');
    setCompanyId();
    setMember((prevList) => {
      const newList = { ...prevList };
      newList.currentSkip = 1;
      return newList;
    });
  };
  const onMenuMemberClick = () => {
    setMenu('member');
    setCompanyId();
    setCompany((prevList) => {
      const newList = { ...prevList };
      newList.currentSkip = 1;
      return newList;
    });
  };

  const handleCompanyUpdate = (data) => {
    api.adminUsersCompanyUpdate(data).then(() => {
      init();
    });
  };

  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menu, bindWechatType, type, sortable, selectedMenuItem.currentSkip]);

  return (
    <div className={styles.app}>
      <div className={styles.table}>
        <Menu pointing secondary>
          <Menu.Item active={menu === 'company'} onClick={onMenuCompanyClick}>
            企业
          </Menu.Item>
          <Menu.Item active={menu === 'member'} onClick={onMenuMemberClick}>
            成员
          </Menu.Item>
        </Menu>
        <div className={styles.box}>
          <Input
            value={selectedMenuItem.search}
            onChange={handleFieldChange}
            action={{
              content: '查找',
              onClick: again,
            }}
            onKeyPress={handleKeyPress}
            placeholder={menu === 'member' ? '用户名/机构名称/邮箱' : '姓名/用户名/机构名称'}
            className={styles.input}
          />
          {menu !== 'company' && (
            <Dropdown
              value={bindWechatType}
              clearable
              placeholder="绑定方式"
              selection
              options={bindWechatOptions}
              onChange={handleMenberbindWechatTypeChange}
            />
          )}
          {menu === 'company' && (
            <Dropdown
              value={type}
              clearable
              placeholder="成员类型"
              selection
              options={options}
              onChange={handleMenberTypeChange}
            />
          )}
        </div>
        <Segment>
          <Dimmer active={isLoad} inverted>
            <Loader inverted />
          </Dimmer>
          {menu === 'company' && (
            <Table celled unstackable fixed sortable>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>姓名（主账户）</Table.HeaderCell>
                  <Table.HeaderCell>用户名（主账户）</Table.HeaderCell>
                  <Table.HeaderCell>用户类型</Table.HeaderCell>
                  <Table.HeaderCell>机构名称</Table.HeaderCell>
                  <Table.HeaderCell>成员数/上限人数</Table.HeaderCell>
                  {/* <Table.HeaderCell>项目数</Table.HeaderCell>
                  <Table.HeaderCell>看板数</Table.HeaderCell>
                  <Table.HeaderCell>任务数</Table.HeaderCell>
                  <Table.HeaderCell>动态数（本月）</Table.HeaderCell> */}
                  <Table.HeaderCell>注册</Table.HeaderCell>
                  <Table.HeaderCell>有效期</Table.HeaderCell>
                  <Table.HeaderCell width={3}>操作</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {!!selectedMenuItem.list.length &&
                  selectedMenuItem.list.map((item) => (
                    <Table.Row key={item.id}>
                      <Table.Cell>
                        {(item.createUserId && item.createUserId.name) || '-'}
                      </Table.Cell>
                      <Table.Cell>
                        {(item.createUserId && item.createUserId.username) || '-'}
                      </Table.Cell>
                      <Table.Cell>
                        {item.expiredAt && item.paysLen ? '付费用户' : '普通用户'}
                      </Table.Cell>
                      <Table.Cell>{item.name || '-'}</Table.Cell>
                      <Table.Cell>
                        <div
                          className={styles.link}
                          onClick={() => {
                            setCompanyId(item.id);
                            setMenu('member');
                          }}
                        >
                          {item.usersLen}/{item.numberOfPeople}
                        </div>
                      </Table.Cell>
                      {/* <Table.Cell>{item.projectsLen}</Table.Cell>
                      <Table.Cell>{item.boardsLen}</Table.Cell>
                      <Table.Cell>{item.cardsLen}</Table.Cell>
                      <Table.Cell>{item.actionsLen}</Table.Cell> */}
                      <Table.Cell>
                        {item.createdAt
                          ? moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
                          : '-'}
                      </Table.Cell>
                      <Table.Cell>
                        {item.expiredAt
                          ? moment(item.expiredAt).format('YYYY-MM-DD HH:mm:ss')
                          : '-'}
                      </Table.Cell>
                      <Table.Cell>
                        <>
                          <CompanyManageNumberEditPopup
                            usersLen={item.usersLen}
                            onUpdate={(data) => {
                              handleCompanyUpdate({ ...data, companyId: item.id });
                            }}
                          >
                            <button type="button" style={{ marginRight: '20px' }}>
                              编辑人数
                            </button>
                          </CompanyManageNumberEditPopup>
                          <CompanyManageExpiredEditPopup
                            defaultValue={item.expiredAt && new Date(item.expiredAt)}
                            onUpdate={(data) => {
                              handleCompanyUpdate({ expiredAt: data, companyId: item.id });
                            }}
                          >
                            <button type="button" style={{ marginRight: '20px' }}>
                              编辑有效期
                            </button>
                          </CompanyManageExpiredEditPopup>
                          <CompanyManageActionsPopup companyId={item.id}>
                            <button type="button">记录</button>
                          </CompanyManageActionsPopup>
                        </>
                      </Table.Cell>
                    </Table.Row>
                  ))}
              </Table.Body>
              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan="8" style={{ textAlign: 'right' }}>
                    <Pagination
                      activePage={selectedMenuItem.currentSkip}
                      totalPages={selectedMenuItem.total}
                      onPageChange={handlePageChange}
                    />
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </Table>
          )}
          {menu === 'member' && (
            <Table celled unstackable fixed sortable>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>用户名</Table.HeaderCell>
                  <Table.HeaderCell>姓名</Table.HeaderCell>
                  <Table.HeaderCell>机构名称</Table.HeaderCell>
                  <Table.HeaderCell>电话</Table.HeaderCell>
                  <Table.HeaderCell>邮箱</Table.HeaderCell>
                  <Table.HeaderCell>绑定方式</Table.HeaderCell>
                  <Table.HeaderCell
                    sorted={sortable.column === 'createdAt' ? sortable.direction : null}
                    onClick={() => {
                      let direction = 'ascending';
                      if (sortable.column === 'createdAt') {
                        direction = sortable.direction === 'ascending' ? 'descending' : 'ascending';
                      }
                      setSortable({
                        column: 'createdAt',
                        direction,
                      });
                    }}
                  >
                    注册时间
                    {sortable.column !== 'createdAt' && <Icon name="sort" />}
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    sorted={sortable.column === 'appearAt' ? sortable.direction : null}
                    onClick={() => {
                      let direction = 'ascending';
                      if (sortable.column === 'appearAt') {
                        direction = sortable.direction === 'ascending' ? 'descending' : 'ascending';
                      }
                      setSortable({
                        column: 'appearAt',
                        direction,
                      });
                    }}
                  >
                    最近登录时间
                    {sortable.column !== 'appearAt' && <Icon name="sort" />}
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {!!selectedMenuItem.list.length &&
                  selectedMenuItem.list.map((item) => (
                    <Table.Row key={item.id}>
                      <Table.Cell>{item.username}</Table.Cell>
                      <Table.Cell>{item.name}</Table.Cell>
                      <Table.Cell>{item.companyId && item.companyId.name}</Table.Cell>
                      <Table.Cell>{item.phone}</Table.Cell>
                      <Table.Cell>{item.email}</Table.Cell>
                      <Table.Cell>{bindType(item)}</Table.Cell>
                      <Table.Cell>
                        {item.createdAt
                          ? moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss')
                          : '-'}
                      </Table.Cell>
                      <Table.Cell>
                        {item.appearAt ? moment(item.appearAt).format('YYYY-MM-DD HH:mm:ss') : '-'}
                      </Table.Cell>
                    </Table.Row>
                  ))}
              </Table.Body>
              <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan="8" style={{ textAlign: 'right' }}>
                    <Pagination
                      activePage={selectedMenuItem.currentSkip}
                      totalPages={selectedMenuItem.total}
                      onPageChange={handlePageChange}
                    />
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>
            </Table>
          )}
        </Segment>
      </div>
    </div>
  );
});

export default UserManage;
